import { render, staticRenderFns } from "./PageFive.vue?vue&type=template&id=203143fa&scoped=true&"
import script from "./PageFive.vue?vue&type=script&lang=js&"
export * from "./PageFive.vue?vue&type=script&lang=js&"
import style0 from "./PageFive.vue?vue&type=style&index=0&id=203143fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203143fa",
  null
  
)

export default component.exports